import HubDbasQuizResultsPage from './HubDbasQuizResultsPage'

export default HubDbasQuizResultsPage
